import { Inter } from 'next/font/google'

/**
 * Ledger's Inter (spec docs/superpowers/specs/2026-09-27-app-ready-made-themes-design.md, "The themes").
 * next/font self-hosts it, so CSP `font-src 'self'` holds. It only defines the variable
 * --font-app-inter (APP_INTER_FONT_VARIABLE in lib/theme/app-themes/app-themes.ts); Ledger uses it by
 * naming the variable in its font-family (components/app-theme/app-theme.css). The other themes reuse
 * the root layout's Geist; Classic keeps today's font.
 *
 * `preload: false`: every app page imports this through the app sidebar, and someone on Classic must
 * never download Ledger's font. Ledger's first paint uses the fallback face for a moment (swap).
 *
 * next/font only accepts literal options, so the variable is spelled out here;
 * components/app-theme/__tests__/app-fonts.spec.ts pins it to the catalogue's.
 */
export const appInter = Inter({ variable: '--font-app-inter', subsets: ['latin'], display: 'swap', preload: false })

/** The class that defines --font-app-inter. On <html> while a ready-made theme is on (app-theme-dom.ts). */
export const APP_INTER_FONT_CLASS: string = appInter.variable
